Drupal.behaviors.mpp_v1 = {
  attach: function (context, settings) {
    var productsData = page_data['catalog-mpp'].categories[0].products;

    site.productView.mpp.init(productsData);
    // product sort
    site.productSort.init(productsData);

    // Personalization MPP initialization
    if (Drupal.ELB.hasPersonalization()) {
      site.profile.mobile.MPP(page_data['catalog-mpp']);
    }
  }
};
